import {
  Button,
  FormModalStyle,
  Form,
  Formik,
  Close,
  Checkbox,
  useRouter,
} from "@/imports-files/components/model/communication-filter";

export function CheckboxFilterModal({
  filters,
  closeState,
  onSubmit,
  onSubmitParams,
  modalHeight,
}) {
  const router = useRouter();
  const initialValues = (filters) => {
    const selectedCategories = Array.isArray(router.query.integration_category)
      ? router.query.integration_category
      : [router.query.integration_category];

    return {
      options: filters.map((x) => ({
        id: x.id,
        value: selectedCategories.includes(String(x.id)),
        label: x.label,
      })),
    };
  };

  return (
    <div className={`${FormModalStyle.ModalOverlay}`}>
      <div className={`${FormModalStyle.Modal}`}>
        <div className={`${FormModalStyle.Modal__Container} ${modalHeight}`}>
          <div
            className={`${FormModalStyle.Modal__Container__CloseSection}`}
            onClick={() => closeState(false)}
          >
            <Close />
            CLOSE
          </div>
          <div className={`${FormModalStyle.Modal__Container__ContentSection}`}>
            <h1
              className={`${FormModalStyle.Modal__Container__ContentSection__Heading}`}
            >
              Filter
            </h1>
            <Formik
              initialValues={initialValues(filters)}
              onSubmit={(values) => {
                const filteredOptions = values.options
                  .filter((option) => option.value === true)
                  .reduce((acc, option) => {
                    acc[option.id] = option.value;
                    return acc;
                  }, {});
                onSubmit(filteredOptions, ...onSubmitParams);
                closeState(false);
              }}
            >
              {(formik) => (
                <Form>
                  <div
                    className={`${FormModalStyle.Modal__Container__ContentSection__Block} mt30`}
                  >
                    {formik.values.options.map((filter, index) => (
                      <div
                        key={filter.id}
                        className={
                          FormModalStyle.Modal__Container__ContentSection__Block__Heading
                        }
                      >
                        <Checkbox
                          defaultChecked={filter.value}
                          name={filter.label}
                          onChange={(event) => {
                            formik.setFieldValue(
                              `options.${index}.value`,
                              event.target.checked
                            );
                          }}
                          checked={filter.value}
                        />
                        {filter.label}
                      </div>
                    ))}
                  </div>
                  <div
                    className={FormModalStyle.Modal__Container__ButtonSection}
                  >
                    <Button
                      buttonstyle={FormModalStyle.secondarybtn}
                      onClick={async () => {
                        formik.resetForm();
                        onSubmit(formik.values, ...onSubmitParams);
                        closeState(false);
                      }}
                    >
                      Reset
                    </Button>
                    <Button
                      buttonstyle={FormModalStyle.primarybtn}
                      type="submit"
                    >
                      Apply
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
}
